<template>
  <div class="scroll-vertical dashboard-container">
    <tiles v-for="(row,i) in rows" :key="i">
      <div v-for="obj in row" :key="obj.id" class="tile is-parent is-6">
        <tile-profile :profile="obj" :title="obj.name" class="is-info"></tile-profile>
      </div>
    </tiles>
  </div>
</template>

<script>
import _ from 'lodash';
import Tiles from '@/components/Tiles.vue';
import TileProfile from '@/components/profiles/tiles/TileProfile.vue';

export default {
  name: 'ProfilesTiles',
  components: { Tiles, TileProfile },
  props: {
    profiles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: 2,
    };
  },
  computed: {
    rows() {
      return _.chunk(this.profiles, this.columns);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
